import React, {useMemo, useState} from 'react';

import RecommendQuestionList from './RecommendQuestionList';

import {Box, Button} from '@mui/material';
import HelpCenterOutlined from '@mui/icons-material/HelpCenterOutlined';
import LibraryBooksOutlined from '@mui/icons-material/LibraryBooksOutlined';
import MailOutlineOutlined from '@mui/icons-material/MailOutlineOutlined';
import SearchRounded from '@mui/icons-material/SearchRounded';

export default function RecommendBtnBox({ botList, currentBotId, handleChangeCurrentBot, handleSendMessage, handleChangeMessage }) {
    const [isOpenQuestionList, setIsOpenQuestionList] = useState(false);

    // botList -> [{ id, type, questionList, name, Icon }] 형태로 변환 (TYPE_MAP에 있는 타입만 허용)
    const botMap = useMemo(() => {
        const recommendBotList = botList ?? [];
        
        return recommendBotList.map(({ id, type, questionList }) => {
            const botType = (type || '').toUpperCase();
            const botInfo = TYPE_MAP[botType];
            
            if (!botInfo) return null;
            const { name, Icon } = botInfo;

            return { id, type, questionList, name, Icon };
        }).filter(Boolean);
    }, [botList]);

    // currentBotId와 일치하는 요소(봇)
    const selectedBot = useMemo(() => {
        return botMap.find(bot => bot.id === currentBotId) ?? null;
    }, [botMap, currentBotId]);

    const openQuestionList = ({ id, type }) => {
        setIsOpenQuestionList(true);
        handleChangeCurrentBot({ id, type });
    };

    const closeQuestionList = () => {
        setIsOpenQuestionList(false);
    };

    return (
        <>
        {isOpenQuestionList
            ? <RecommendQuestionList
                selectedBot={selectedBot}
                closeQuestionList={closeQuestionList}
                handleChangeMessage={handleChangeMessage}
                handleSendMessage={handleSendMessage}
            />
            : <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
                {botMap.map((bot, index) => {
                    const { id, type, name, Icon } = bot;

                    return (
                        <Button
                            key={index}
                            sx={{ border: '1px solid', borderColor: 'grey.400', color: 'text.disabled', '&:hover': { backgroundColor: 'grey.50' } }}
                            size='large'
                            variant='outlined'
                            startIcon={<Icon />}
                            onClick={() => openQuestionList({ id, type })}
                        >
                            {name}
                        </Button>
                    )
                })}
            </Box>
        }
        </>
    );
}

const TYPE_MAP = {
    DATABASE: { name: 'DB 질문', Icon: SearchRounded },
    DOCUMENT: { name: '문서 질문', Icon: LibraryBooksOutlined },
    EMAIL: { name: '이메일 질문', Icon: MailOutlineOutlined },
    FAQ: { name: 'FAQ 질문', Icon: HelpCenterOutlined }
};
